<template>
  <div class="news-page">
    <div class="top-image">
      <img :src="topImageSrc">
      <div class="top-mask"></div>
      <div class="top-text">
        <div class="main-title">{{ $dt(menuInfo, 'name') }}</div>
      </div>
    </div>
    <div class="body-box">
      <div class="content-box">
        <div class="query-form">
          <div class="type-box">
            <div v-for="item in newsType" :key="item._id"
                 class="type-item" :class="{'active-type': item.code === queryForm.type}" @click="pickType(item)">
              {{ $dt(item, 'text') }}
            </div>
          </div>
          <a-input class="search-input" v-model:value="queryForm.searchStr" :placeholder="$t('请输入关键字搜索')">
            <template #suffix>
              <dol-icon type="SearchOutlined" />
            </template>
          </a-input>
        </div>
        <dol-list :card-flag="false" url="/portal/newsList" :query-data="queryForm"
                  :defaultPageSize="12" :paginationShowSizeChanger="false" ref="list">
          <template #customerContent="{ data, total }">
            <a-row :gutter="[28,64]">
              <a-col v-for="record in data" :key="record._id" :span="8">
                <div class="news-item" @click="goDetail(record)">
                  <img class="news-image" :src="$Dolphin.path.publicPath + $dt(record,'image').filePath" />
                  <div class="news-title">{{ $dt(record, 'title') }}</div>
                  <div class="news-remark">{{ $dt(record, 'remark') }}</div>
                  <div class="news-time">{{ $dayjs(record.updateTime).format('YYYY-MM-DD') }}</div>
                </div>
              </a-col>
            </a-row>
          </template>
        </dol-list>
      </div>
    </div>
  </div>
</template>

<script>
import defaultTopImage from '../../../public/static/customPage/defaultTop.png';

export default {
  name: "news",
  data() {
    return {
      menuInfo: {},
      queryForm: { type: '', searchStr: '' },
      newsList: [],
      newsType: [],
    };
  },
  computed: {
    topImageSrc() {
      const image = this.menuInfo.image;
      return image?.filePath ? this.$Dolphin.path.publicPath + image.filePath : defaultTopImage;
    }
  },
  methods: {
    queryMenu() {
      this.$ajax({
        url: '/portal/queryPageNotConfig',
        params: { link: '/news' },
      }).then(({ data, rows }) => {
        this.menuInfo = data;
      });
    },
    pickType(item) {
      this.queryForm.type = item.code;
      this.query();
    },
    goDetail(item) {
      this.$router.push(`/newsDetail?id=${item._id}`);
    },
    query() {
      this.$refs.list.query();
    },
  },
  async created() {
    this.queryMenu();
    let newsType = await this.$dict('newsType');
    newsType = JSON.parse(JSON.stringify(newsType));
    newsType.unshift({ code: '', text: '全部', textEn: 'All', _id: '1' });
    this.newsType = newsType;
  },
};
</script>

<style lang="scss">
.news-page {
  width: 100%;
  font-family: "alph";

  .top-image {
    position: relative;
    width: 100%;
    min-height: 300px;

    img {
      width: 100%;
      display: block;
      height: auto;
    }

    .top-mask {
      position: absolute;
      inset: 0;
      background-color: rgba(0, 0, 0, 0.3);
    }

    .top-text {
      position: absolute;
      bottom: 100px;
      left: 0;
      right: 0;
      text-align: center;
      color: #fff;

      .main-title {
        font-size: 32px;
        font-weight: 600;
        margin-bottom: 24px;
      }

      .sub-title {
        font-size: 16px;
        font-weight: 600;
      }
    }
  }

  .body-box {
    padding: 96px 0;

    .content-box {
      width: 1280px;
      margin: 0 auto;
    }

    .query-form {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 56px;

      .type-box {
        display: flex;
        height: 56px;
        cursor: pointer;

        .type-item {
          background: #e7ecf2;
          line-height: 56px;
          padding: 0 44px;
          font-size: 20px;
          color: #333333;
          font-weight: bold;
        }

        .active-type {
          background: #003C82;
          color: white;
        }
      }

      .search-input {
        width: 313px;
      }
    }

    .news-item {
      height: 100%;
      cursor: pointer;

      //&:hover {
      //transform: scale(1.02);
      //box-shadow: 0 16px 32px rgba(0, 30, 70, 0.05), 0 8px 16px rgba(0, 30, 70, 0.05);
      //z-index: 10;
      //}

      .news-image {
        height: 280px;
        width: 100%;
        object-fit: cover;
        margin-bottom: 16px;
      }

      .news-title {
        font-size: 20px;
        color: #003C82;
        line-height: 28px;
        font-weight: bold;
        margin-bottom: 8px;
      }

      .news-remark {
        color: #333333;
        line-height: 20px;
        margin-bottom: 8px;
      }

      .news-time {
        color: #999999;
        line-height: 20px;
      }
    }

    .dol-list-customer-content-pagination {
      display: flex;
      justify-content: flex-end;
      margin-top: 12px;
    }
  }
}
</style>
